export default defineNuxtPlugin({
  enforce: "pre",
  setup(nuxtApp) {
    nuxtApp.hook("openFetch:onRequest", (ctx) => {
      const token = useUserToken().value;
      const loginAsUser = useLoginAsUser();

      if (token) {
        if (ctx.options.headers) {
          const isProfileConfigEndpoint = typeof ctx.request === "string" && ctx.request.includes("/profile/config");

          ctx.options.headers.set("Authorization", `Bearer ${token}`);
          // Add x-login-as header if user is loginAsUser is set
          const loginAsUserId = loginAsUser.state?.id;
          if (loginAsUserId && !isProfileConfigEndpoint) {
            ctx.options.headers.set("X-Login-As", loginAsUserId);
          }
        }
        else {
          ctx.options.headers = new Headers();
          ctx.options.headers.set("Authorization", `Bearer ${token}`);
        }
      }
    });

    nuxtApp.hook("openFetch:onRequestError", () => {
      // Since we can't access the status code here and check for 401 - we're assuming that any request error is a session error,
      // until we will have a fix by DevOps team for ISTIO service: https://github.com/istio/istio/issues/29425
      navigateToLogin({ errorCode: "session-expired" });
    });
    nuxtApp.hook("openFetch:onResponseError", (ctx) => {
      if (ctx.response.status === 401) navigateToLogin({ errorCode: "session-expired" });
    });
  },
});
